import React, { Component } from 'react';
import SortableTable from './SortableTable';
import './dataImport.scss';
import { Modal } from 'react-bootstrap';
import StaticLoader from '../../../../common/loader/StaticLoader';
import DownloadTemplateModal from './modals/downloadImportTemplateModal';
import ImportDataModal from './modals/importDataModal';
import { connect } from 'react-redux';
import { fetchPreviousImports, fetchCustomFieldsForImport } from './actions';

const  templateTypes = [
  { id: 1, name: 'Insureds Import Template' },
  { id: 2, name: 'Projects Import Template' },
  { id: 3, name: 'Project & Insured Connections Import Template' },
  { id: 4, name: 'Single-Step PI Import Template' }
];

class DataImports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDownloadModal: false,
      showImportModal: false,
      imports: []
    };
  }
  componentDidMount() {
    this.props.dispatch(fetchPreviousImports(this.props.holderId));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imports !== this.props.imports) {
      this.setState({ imports: Array.isArray(this.props.imports) ? this.props.imports : [] });
    }
  }

  openDownloadModal = () => {
    this.setState({ showDownloadModal: true });
  };

  closeDownloadModal = () => {
    this.setState({ showDownloadModal: false });
  };

  openImportModal = () => {
    this.props.dispatch(fetchCustomFieldsForImport(this.props.holderId));
    this.setState({ showImportModal: true });
  };

  closeImportModal = () => {
    this.setState({ showImportModal: false });
  };

  handleImportStart = (importEntry) => {
    if (!importEntry) return;

    this.setState(prevState => ({
      imports: [
        importEntry,
        ...prevState.imports
      ]
    }));
  };

  handleImportStatusChange = (importId, updates) => {
    if (!importId || !updates) return;

    this.setState(prevState => ({
      imports: prevState.imports.map(importItem => (
        importItem.id === importId
          ? {
            ...importItem,
            ...updates
          }
          : importItem
      ))
    }));
  };

  render() {
    const { imports } = this.state;

    return (
      <div className='data-imports-tab-container'>
        <div className='button-container'>
          <button onClick={this.openDownloadModal} className='btn btn-download' >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.08301 9.33301C2.49722 9.33301 2.83301 9.66879 2.83301 10.083V12.7497C2.83301 12.9044 2.89447 13.0528 3.00386 13.1622C3.11326 13.2715 3.26163 13.333 3.41634 13.333H12.7497C12.9044 13.333 13.0528 13.2715 13.1622 13.1622C13.2716 13.0528 13.333 12.9044 13.333 12.7497V10.083C13.333 9.66879 13.6688 9.33301 14.083 9.33301C14.4972 9.33301 14.833 9.66879 14.833 10.083V12.7497C14.833 13.3022 14.6135 13.8321 14.2228 14.2228C13.8321 14.6135 13.3022 14.833 12.7497 14.833H3.41634C2.86381 14.833 2.3339 14.6135 1.9432 14.2228C1.5525 13.8321 1.33301 13.3022 1.33301 12.7497V10.083C1.33301 9.66879 1.66879 9.33301 2.08301 9.33301Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.21967 6.21967C4.51256 5.92678 4.98744 5.92678 5.28033 6.21967L8.08333 9.02267L10.8863 6.21967C11.1792 5.92678 11.6541 5.92678 11.947 6.21967C12.2399 6.51256 12.2399 6.98744 11.947 7.28033L8.61366 10.6137C8.32077 10.9066 7.8459 10.9066 7.553 10.6137L4.21967 7.28033C3.92678 6.98744 3.92678 6.51256 4.21967 6.21967Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.08301 1.33301C8.49722 1.33301 8.83301 1.66879 8.83301 2.08301V10.083C8.83301 10.4972 8.49722 10.833 8.08301 10.833C7.66879 10.833 7.33301 10.4972 7.33301 10.083V2.08301C7.33301 1.66879 7.66879 1.33301 8.08301 1.33301Z"/>
            </svg>
            <span className="btn-text">Download Import Template</span>
          </button>
          <button onClick={this.openImportModal} className='btn btn-import'>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2 9.25C2.41421 9.25 2.75 9.58579 2.75 10V12.6667C2.75 12.8214 2.81146 12.9697 2.92085 13.0791C3.03025 13.1885 3.17862 13.25 3.33333 13.25H12.6667C12.8214 13.25 12.9697 13.1885 13.0791 13.0791C13.1885 12.9697 13.25 12.8214 13.25 12.6667V10C13.25 9.58579 13.5858 9.25 14 9.25C14.4142 9.25 14.75 9.58579 14.75 10V12.6667C14.75 13.2192 14.5305 13.7491 14.1398 14.1398C13.7491 14.5305 13.2192 14.75 12.6667 14.75H3.33333C2.7808 14.75 2.25089 14.5305 1.86019 14.1398C1.46949 13.7491 1.25 13.2192 1.25 12.6667V10C1.25 9.58579 1.58579 9.25 2 9.25Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.47 1.46967C7.76289 1.17678 8.23776 1.17678 8.53066 1.46967L11.864 4.803C12.1569 5.0959 12.1569 5.57077 11.864 5.86366C11.5711 6.15656 11.0962 6.15656 10.8033 5.86366L8.00033 3.06066L5.19732 5.86366C4.90443 6.15656 4.42956 6.15656 4.13666 5.86366C3.84377 5.57077 3.84377 5.0959 4.13666 4.803L7.47 1.46967Z"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V10C8.75 10.4142 8.41421 10.75 8 10.75C7.58579 10.75 7.25 10.4142 7.25 10V2C7.25 1.58579 7.58579 1.25 8 1.25Z"/>
            </svg>
            <span className="btn-text">Import Data</span>
          </button>
        </div>

        <div className="imported-list mt-6">
          {this.props.isFetchingPreviousImports ? (
            <StaticLoader />
          ) : (
            <SortableTable data={imports} />
          )}
        </div>
        {this.state.showDownloadModal && (
          <Modal
            show={true}
            onHide={this.closeDownloadModal}
            className="add-item-modal add-entity-small"
          >
            <Modal.Body>
              <DownloadTemplateModal 
                onClose={this.closeDownloadModal}
                data={imports}
                templateTypes={templateTypes}
              />
            </Modal.Body>
          </Modal>
        )}
  
        {this.state.showImportModal && (
          <Modal
            show={true}
            onHide={this.closeImportModal}
            className="add-item-modal add-entity-small"
          >
            <Modal.Body>
              <ImportDataModal
                onClose={this.closeImportModal}
                templateTypes={templateTypes}
                customFields={this.props.customFields}
                onImportStart={this.handleImportStart}
                onImportStatusChange={this.handleImportStatusChange}
              />
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const dataImports = state.dataImports || {};

  return {
    imports: Array.isArray(dataImports.previousImports) ? dataImports.previousImports : [],
    isFetchingPreviousImports: !!dataImports.fetchingPreviousImports,
    customFields: Array.isArray(dataImports.customFields) ? dataImports.customFields : []
  };
};

export default connect(mapStateToProps)(DataImports);